getDefaultFetchPolicy